import LazyLoad from 'vanilla-lazyload';

import setupRedirects from './setupRedirects';

declare global {
  interface Window {
    lazyLoadInstance: InstanceType<typeof LazyLoad>;
  }
}

setupRedirects();

window.lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
});
